import React from "react";
import ReportDetail from "../ReportDetail";
import ComplaintsReport from "./ComplaintsReport";

const Complaints = () => {
  return (
    <ReportDetail title="complaints_report">
      <ComplaintsReport />
    </ReportDetail>
  );
};

export default Complaints;
